// Karussell-Navigation fuer Wirkstoffe-Section
// Touch-Swipe via CSS scroll-snap, JS nur fuer Pfeil-Klick + aria-disabled-Update

(function () {
  'use strict';

  // Drag-Scroll nur fuer Maus-Nutzer (feiner Pointer, kein Touch)
  const enableDragScroll = (list) => {
    if (!window.matchMedia('(pointer: fine)').matches) return;

    let isDragging = false;
    let startX;
    let scrollLeft;

    list.addEventListener('mousedown', (e) => {
      // Text- und Image-Selektion beim Drag verhindern
      e.preventDefault();
      isDragging = true;
      list.classList.add('is-dragging');
      startX = e.pageX - list.offsetLeft;
      scrollLeft = list.scrollLeft;
    });

    list.addEventListener('mouseleave', () => {
      isDragging = false;
      list.classList.remove('is-dragging');
    });

    list.addEventListener('mouseup', () => {
      isDragging = false;
      list.classList.remove('is-dragging');
    });

    list.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - list.offsetLeft;
      const walk = (x - startX) * 1.5;
      list.scrollLeft = scrollLeft - walk;
    });
  };

  const karussells = document.querySelectorAll('[data-karussell]');

  karussells.forEach((karussell) => {
    const list = karussell.querySelector('[data-karussell-list]');
    const navPrev = karussell.querySelector('[data-nav="prev"]');
    const navNext = karussell.querySelector('[data-nav="next"]');

    if (!list || !navPrev || !navNext) return;

    // Karten-Breite + Gap dynamisch ermitteln
    const getScrollAmount = () => {
      const card = list.querySelector('.pdp-wirkstoffe__card');
      if (!card) return 0;
      const cardRect = card.getBoundingClientRect();
      const computedStyle = window.getComputedStyle(list);
      const gap = parseFloat(computedStyle.gap) || 0;
      return cardRect.width + gap;
    };

    // Scroll-Verhalten: instant bei prefers-reduced-motion
    const getScrollBehavior = () => {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'instant'
        : 'smooth';
    };

    // aria-disabled und disabled der Pfeil-Buttons aktualisieren
    const updateNavState = () => {
      const scrollLeft = list.scrollLeft;
      const maxScroll = list.scrollWidth - list.clientWidth;

      const isAtStart = scrollLeft <= 1;
      navPrev.disabled = isAtStart;
      navPrev.setAttribute('aria-disabled', String(isAtStart));

      const isAtEnd = scrollLeft >= maxScroll - 1;
      navNext.disabled = isAtEnd;
      navNext.setAttribute('aria-disabled', String(isAtEnd));
    };

    navPrev.addEventListener('click', () => {
      list.scrollBy({ left: -getScrollAmount(), behavior: getScrollBehavior() });
    });

    navNext.addEventListener('click', () => {
      list.scrollBy({ left: getScrollAmount(), behavior: getScrollBehavior() });
    });

    // Tastatur-Navigation: Pfeiltasten scrollen eine Karten-Breite
    list.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        list.scrollBy({ left: getScrollAmount(), behavior: getScrollBehavior() });
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        list.scrollBy({ left: -getScrollAmount(), behavior: getScrollBehavior() });
      }
    });

    // Nach Touch-Swipe ebenfalls Pfeil-Status aktualisieren
    list.addEventListener('scroll', updateNavState);

    // Initial-Status setzen
    updateNavState();

    // Dots via IntersectionObserver (nur auf Mobile – CSS blendet auf Desktop aus)
    const dotsContainer = karussell.parentElement.querySelector('[data-karussell-dots]');
    if (dotsContainer && 'IntersectionObserver' in window) {
      const dots = Array.from(dotsContainer.querySelectorAll('.pdp-wirkstoffe__dot'));
      const cards = Array.from(list.querySelectorAll('.pdp-wirkstoffe__card'));

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const idx = cards.indexOf(entry.target);
            const page = Math.floor(idx / 2);
            dots.forEach((d, i) =>
              d.classList.toggle('pdp-wirkstoffe__dot--active', i === page)
            );
          });
        },
        { root: list, threshold: 0.6 }
      );

      // Nur die erste Karte jeder Seite beobachten
      cards.forEach((card, i) => {
        if (i % 2 === 0) observer.observe(card);
      });
    }

    // Bei Resize neu berechnen (responsive Karten-Breite aendert sich)
    window.addEventListener('resize', updateNavState);

    // Desktop-Drag-Swipe aktivieren
    enableDragScroll(list);
  });
})();
